/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const AgencyProjectCorrespondence = {

	delete (context, attachmentId, onSuccess, onError, options) {
		Api.delete(context,
			"/agency-project-correspondence"
			+ "?attachmentId=" + attachmentId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDownload (context, attachmentId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-project-correspondence/download"
			+ "?attachmentId=" + attachmentId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getList (context, agencyProjectId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-project-correspondence/list"
			+ "?agencyProjectId=" + agencyProjectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	post (context, file, agencyProjectId, onSuccess, onError, options) {
		Api.post(context,
			"/agency-project-correspondence"
			+ "?file=" + file
			+ "&agencyProjectId=" + agencyProjectId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
